module.exports = __webpack_public_path__ + "img/header-weddingRingsWomen.e364553.jpg";